import { createSelector } from 'reselect';
import { AppState } from '$/store';
import * as Bixby from '$/core';

// ----- Current User -----

// CreditSightsAnalyst
const getIsCurrentUserCreditSightsAnalyst = ({ profileState }: AppState) =>
  !!(profileState && profileState.profile && profileState.profile.isCreditSightsAnalyst);
export const getIsCurrentUserCreditSightsAnalystState = createSelector([getIsCurrentUserCreditSightsAnalyst], (isCreditSightsAnalyst: boolean) => ({ isCreditSightsAnalyst }));

// SuFAnalyst
const getIsCurrentUserSuFAnalyst = ({ profileState }: AppState) =>
  !!(profileState && profileState.profile && profileState.profile.isSufAnalyst);
export const getIsCurrentUserSuFAnalystState = createSelector([getIsCurrentUserSuFAnalyst], (isSuFAnalyst: boolean) => ({ isSuFAnalyst }));

// RatingssAnalyst
const getIsCurrentUserRatingsAnalyst = ({ profileState }: AppState) =>
  !!(profileState && profileState.profile && profileState.profile.isRatingsAnalyst);
export const getIsCurrentUserRatingsAnalystState = createSelector([getIsCurrentUserRatingsAnalyst], (isRatingsAnalyst: boolean) => ({ isRatingsAnalyst }));

// CreditSightsOps
const getIsCurrentUserCreditSightsOps = ({ profileState }: AppState) =>
  !!(profileState && profileState.profile && profileState.profile.isCreditSightsOps);
export const getIsCurrentUserCreditSightsOpsState = createSelector([getIsCurrentUserCreditSightsOps], (isCreditSightsOps: boolean) => ({ isCreditSightsOps }));

// Admin
const getIsCurrentUserAdmin = ({ profileState }: AppState) =>
  !!(profileState && profileState.profile && profileState.profile.isAdmin);
export const getIsCurrentUserAdminState = createSelector([getIsCurrentUserAdmin], (isAdmin: boolean) => ({ isAdmin }));

// SuperAdmin
const getIsCurrentUserSuperAdmin = ({ profileState }: AppState) =>
  !!(profileState && profileState.profile && profileState.profile.isSuperAdmin);
export const getIsCurrentUserSuperAdminState = createSelector(
  [getIsCurrentUserSuperAdmin],
  (isSuperAdmin: boolean) => ({ isSuperAdmin })
);

// DocHostingAdmin
const getIsCurrentUserDocHostingAdmin = ({ profileState }: AppState) => {
  return !!(profileState && profileState.profile && profileState.profile.isDocHostingAdmin);
};
export const getIsCurrentUserDocHostingAdminState = createSelector(
  [getIsCurrentUserDocHostingAdmin],
  (isDocHostingAdmin: boolean) => ({ isDocHostingAdmin })
);

// ClientComplianceAdmin
const getIsCurrentUserClientComplianceAdmin = ({ profileState }: AppState) => {
  return !!(profileState && profileState.profile && profileState.profile.isClientComplianceAdmin);
};
export const getIsCurrentUserClientComplianceAdminState = createSelector(
  [getIsCurrentUserClientComplianceAdmin],
  (isClientComplianceAdmin: boolean) => ({ isClientComplianceAdmin })
);

// BixbyComplianceAdmin
const getIsCurrentUserBixbyComplianceAdmin = ({ profileState }: AppState) => {
  return !!(profileState && profileState.profile && profileState.profile.isBixbyComplianceAdmin);
};
export const getIsCurrentUserBixbyComplianceAdminState = createSelector(
  [getIsCurrentUserBixbyComplianceAdmin],
  (isBixbyComplianceAdmin: boolean) => ({ isBixbyComplianceAdmin })
);

// CompanyMNPIInfoAdmin
const getIsCurrentUserCompanyMNPIInfoAdmin = ({ profileState }: AppState) => {
  return !!(profileState && profileState.profile && profileState.profile.isCompanyMnpiInfoAdmin);
};
export const getIsCurrentUserCompanyMNPIInfoAdminState = createSelector(
  [getIsCurrentUserCompanyMNPIInfoAdmin],
  (isCompanyMNPIInfoAdmin: boolean) => ({ isCompanyMNPIInfoAdmin })
);

// CompanyPublicInfoAdmin
const getIsCurrentUserCompanyPublicInfoAdmin = ({ profileState }: AppState) => {
  return !!(profileState && profileState.profile && profileState.profile.isCompanyPublicInfoAdmin);
};
export const getIsCurrentUserCompanyPublicInfoAdminState = createSelector(
  [getIsCurrentUserCompanyPublicInfoAdmin],
  (isCompanyPublicInfoAdmin: boolean) => ({ isCompanyPublicInfoAdmin })
);

// Client Consultant
const getIsCurrentUserClientConsultant = ({ profileState }: AppState) =>
  !!(profileState && profileState.profile && profileState.profile.isClientConsultant);
export const getIsCurrentUserClientConsultantState = createSelector([getIsCurrentUserClientConsultant], (isClientConsultant: boolean) => ({
  isClientConsultant,
}));

// Client
const getIsCurrentUserClient = ({ profileState }: AppState) =>
  !!(profileState && profileState.profile && profileState.profile.isClient);
export const getIsCurrentUserClientState = createSelector([getIsCurrentUserClient], (isClient: boolean) => ({
  isClient,
}));

// LegalAdmin
const getIsCurrentUserLegalAdmin = ({ profileState }: AppState) => {
  return !!(profileState && profileState.profile && profileState.profile.isLegalAdmin);
};
export const getIsCurrentUserLegalAdminState = createSelector(
  [getIsCurrentUserLegalAdmin],
  (isLegalAdmin: boolean) => ({ isLegalAdmin })
);


// ----- Selected User -----

// BixbyComplianceAdmin
const getIsSelectedUserBixbyComplianceAdmin = ({ userState }: AppState) =>
  !!(
    userState &&
    userState.currentUser &&
    userState.currentUser.roles &&
    userState.currentUser.roles.find(x => x.toLowerCase() === Bixby.Constants.LOGIN_ROLES_BIXBYCOMPLIANCEADMIN)
  );
export const getIsSelectedUserBixbyComplianceAdminState = createSelector(
  [getIsSelectedUserBixbyComplianceAdmin],
  (isBixbyComplianceAdmin: boolean) => ({ isBixbyComplianceAdmin })
);

// CompanyMNPIInfoAdmin
const getIsSelectedUserCompanyMNPIInfoAdmin = ({ userState }: AppState) =>
  !!(
    userState &&
    userState.currentUser &&
    userState.currentUser.roles &&
    userState.currentUser.roles.find(x => x.toLowerCase() === Bixby.Constants.LOGIN_ROLES_COMPANYMNPIINFOADMIN)
  );
export const getIsSelectedUserCompanyMNPIInfoAdminState = createSelector(
  [getIsSelectedUserCompanyMNPIInfoAdmin],
  (isCompanyMNPIInfoAdmin: boolean) => ({ isCompanyMNPIInfoAdmin })
);

// SuperAdmin
const getIsSelectedUserAdmin = ({ userState }: AppState) =>
  !!(
    userState &&
    userState.currentUser &&
    userState.currentUser.roles &&
    userState.currentUser.roles.find(x => (x && x.toLowerCase() === 'admin') || x.toLowerCase() === 'superadmin')
  );
export const getIsSelectedUserAdminState = createSelector([getIsSelectedUserAdmin], (isAdmin: boolean) => ({
  isAdmin,
}));


// Client
const getIsSelectedUserClient = ({ userState }: AppState) =>
  !!(
    userState &&
    userState.currentUser &&
    userState.currentUser.roles &&
    userState.currentUser.roles.find(x => x && x.toLowerCase() === 'client')
  );
export const getIsSelectedUserClientState = createSelector([getIsSelectedUserClient], (isClient: boolean) => ({
  isClient,
}));

// Client Compliance Admin
const getIsSelectedUserClientComplianceAdmin = ({ userState }: AppState) =>
  !!(
    userState &&
    userState.currentUser &&
    userState.currentUser.roles &&
    userState.currentUser.roles.find(x => x.toLowerCase() === Bixby.Constants.LOGIN_ROLES_CLIENTCOMPLIANCEADMIN)
  );
export const getIsSelectedUserClientComplianceAdminState = createSelector(
  [getIsSelectedUserClientComplianceAdmin],
  (isClientComplianceAdmin: boolean) => ({ isClientComplianceAdmin })
);